export default __webpack_public_path__ + "assets/icon-horizontal-threedots.48dddecd.webp";